import { Modal } from 'modals/Modal';
import { hideModal } from 'modules/main/store/ducks/modal.actions';
import { useMainDispatch } from 'modules/main/store/hooks/useMainDispatch';
import { humanDate } from 'utils/date';

import { GradProgramContactSeeMoreInfoModalProps } from './GradProgramContactSeeMoreInfoModalProps';

export function GradProgramContactSeeMoreInfoModal({
  contact,
}: GradProgramContactSeeMoreInfoModalProps) {
  const dispatch = useMainDispatch();
  return (
    <Modal
      title={
        /* TRANSLATORS: Grad Program admin modal that shows contact details */
        getText('More info')
      }
      onClose={() => {
        dispatch(hideModal());
      }}
      data-qa-id="grad-program-contact-see-more-info-modal"
    >
      <>
        <p>
          {getText('Email')}: {contact.email}
        </p>
        <p>
          {getText('First name')}: {contact.firstName}
        </p>
        <p>
          {getText('Last name')}: {contact.lastName}
        </p>
        {contact.interestedInDegreeProgram ? (
          <p>
            {getText('Interested in degree program')}:{' '}
            {contact.interestedInDegreeProgram}
          </p>
        ) : null}
        <p>
          {getText('Expected enrollment date')}:{' '}
          {contact.expectedEnrollmentDate}
        </p>
        <p>
          {getText('Notes')}: {contact.notes}
        </p>
        <p>
          {getText('Date Shared')}: {humanDate(contact.created)}
        </p>
      </>
    </Modal>
  );
}
